export enum AvailableEntityFolderTypes {
  PARENT = 'parent',
  CHILD = 'child',
}
